import { connect } from 'react-redux';
import { getPrice } from '../utils/seatMapContentContainerUtils';
import { isSelected } from '../utils/selection';
import { getTravelers } from '../utils/seatMapContainerUtils';
import { getTravelerNames } from '../../common/utils/travelerNames';
import { getTravelerGender } from '../../common/utils/travelerGender';
import SeatMapProduct from '../components/SeatMapProduct';
import { getSeatMapData } from '../utils/seatMapTransformer';
export const mapStateToProps = (state, _ref) => {
  let {
    form,
    order,
    travelerLabel
  } = _ref;
  const travelerFormNames = getTravelerNames(form, state, order.travelers || []);
  const travelerFormGender = getTravelerGender(form, state, order.travelers || []);
  const travelers = getTravelers(order, travelerFormNames, travelerLabel, travelerFormGender);
  const isSeatMapSelected = isSelected('seatMap', form)(state);
  return {
    travelers,
    isSeatMapSelected,
    priceRaw: isSeatMapSelected ? getPrice('seatMap', form)(state).price : 0,
    bounds: getSeatMapData(order)
  };
};
export default connect(mapStateToProps)(SeatMapProduct);
//# sourceMappingURL=SeatMapContainer.js.map